import './style.scss'

import clsx from 'clsx'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader.tsx'
import { campaignHooks } from 'features/campaigns/index.ts'
import * as Contacts from 'features/contacts'

import css from './CampaignContacts.module.scss'
import { ContactsFlow } from './Contacts'
import { ExecutionsFlow } from './Executions'

export function SingleContactsPage() {
	campaignHooks.useValidId()

	const { campaign, isLoading, isSuccess } = campaignHooks.useCurrent()

	const isCompose = campaign?.state === 'Compose',
		isRunning = !isCompose

	return (
		<main className={clsx(css.main, 'main app-scroll')}>
			{isLoading && <FullLoader className={css.loader} />}

			<Contacts.ui.AddModal />
			{isSuccess && isCompose && <ContactsFlow />}
			{isSuccess && isRunning && <ExecutionsFlow />}

			<Contacts.ui.FiltersModal />
		</main>
	)
}
